import React from 'react';
import { statusBadge, FONT, RADIUS } from '../ss/tokens';

/**
 * Status badge — colors come from the BDS canonical status map in ss/tokens.
 * Unknown statuses render neutral gray.
 */
export default function Badge({ value }) {
  const { background, color } = statusBadge(value);
  return (
    <span style={{
      padding: '3px 10px',
      borderRadius: RADIUS.pill,
      fontSize: FONT.size.sm,
      fontWeight: FONT.weight.bold,
      background,
      color,
      letterSpacing: '0.04em',
      whiteSpace: 'nowrap',
    }}>
      {value}
    </span>
  );
}
